import { showToast } from "@/utils/toastHelper";

// تابع کنترل ورودی کاراکترها (برای event keypress)
export function passwordKeypress(event) {
  const char = event.key;
   if (char === "Enter") return;
  const validChars = /^[A-Za-z0-9!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?`~]$/;

  if (!validChars.test(char)) {
    event.preventDefault();
    showToast(
      "رمز عبور فقط می‌تواند شامل حروف انگلیسی، اعداد و کاراکترهای ویژه باشد",
      "error"
    );
  }
}

// تابع اعتبارسنجی کامل رمز عبور با نمایش خطاها
export function validatePassword(password) {
  const rules = [
    { regex: /.{10,}/, message: "رمز عبور باید حداقل 10 کاراکتر باشد" },
    { regex: /[0-9]/, message: "رمز عبور باید حداقل یک عدد داشته باشد" },
    { regex: /[A-Z]/, message: "رمز عبور باید حداقل یک حرف بزرگ داشته باشد" },
    { regex: /[a-z]/, message: "رمز عبور باید حداقل یک حرف کوچک داشته باشد" },
    {
      regex: /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?`~]/,
      message: "رمز عبور باید حداقل یک کاراکتر ویژه داشته باشد",
    },
    {
      regex: /^[A-Za-z0-9!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?`~]+$/,
      message:
        "رمز عبور فقط می‌تواند شامل حروف انگلیسی، اعداد و کاراکترهای ویژه باشد",
    },
  ];

  let valid = true;
  let message = "";
  for (const rule of rules) {
    if (!rule.regex.test(password)) {
      message += rule.message;
      message += "<br>";
      valid = false;
    }
  }
  if (!valid) showToast(message, "error");
  return valid;
}
export function numericKeypress(event) {
  const char = event.key;

  // فقط اجازه اعداد 0-9
  const isDigit = /^[0-9]$/;

  if (!isDigit.test(char)) {
    event.preventDefault();
    showToast("لطفاً فقط عدد وارد کنید", "error");
  }
}
export function validateNationalCode(nationalCode) {
  if (!/^\d{10}$/.test(nationalCode)) return false;
  switch (nationalCode) {
    case "0000000000":
    case "1111111111":
    case "2222222222":
    case "3333333333":
    case "4444444444":
    case "5555555555":
    case "6666666666":
    case "7777777777":
    case "8888888888":
    case "9999999999":
      return false;
  }
  var check = parseInt(nationalCode[9]);
  var sum = 0;
  var i;
  for (i = 0; i < 9; ++i) {
    sum += parseInt(nationalCode[i]) * (10 - i);
  }
  sum %= 11;

  return (sum < 2 && check == sum) || (sum >= 2 && check + sum == 11);
  return true;
}
